import { render, staticRenderFns } from "./NewPromo.vue?vue&type=template&id=7e3ba7ac&scoped=true"
import script from "./NewPromo.vue?vue&type=script&lang=js"
export * from "./NewPromo.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NewPromo.vue?vue&type=style&index=1&id=7e3ba7ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3ba7ac",
  null
  
)

export default component.exports